var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApedCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.543,
    height: 14.543,
    viewBox: "0 0 14.543 14.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aped-call",
    transform: "translate(-133.603 -58.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M134.421,70.541h8.907a2.809,2.809,0,0,0,2.818-2.818V58.816A2.809,2.809,0,0,0,143.328,56h-8.907a2.808,2.808,0,0,0-2.818,2.818v8.907A2.808,2.808,0,0,0,134.421,70.541Zm.491-11.943a.871.871,0,0,1,1.072-.091l1.491,1.472a.854.854,0,0,1-.018,1.291l-.691.691a8.443,8.443,0,0,0,3.436,3.472l.891-.873a.712.712,0,0,1,.945.055l1.509,1.472a.813.813,0,0,1-.055,1.236,2.527,2.527,0,0,1-2.345.818,8.634,8.634,0,0,1-3.781-1.836c-3.309-2.89-3.327-4.817-3.327-4.817a2.988,2.988,0,0,1,.873-2.89Z",
    transform: "translate(2 3)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApedCall);
export default __webpack_public_path__ + "static/media/aped-call.837cfba3742f0e8b8ba0cc4e1b0d7d01.svg";
export { ForwardRef as ReactComponent };